import React from "react";

import { usePageConfiguration } from "@features/sales-v3/hooks";
import { type Compare } from "@features/sales-v3/hooks/use-chart-state";
import { type GetCompareQueryMetadata } from "@features/sales-v3/utils/compare-query";

import { MenuSubmenuItem } from "./menu-submenu-item";

interface TimePeriodSelectorProps {
  compare: Compare;
  updateCompare: (compare: Compare) => void;
  getCompareQueryMetadata: GetCompareQueryMetadata;
  isDisabled?: boolean;
}

export const TimePeriodSelector = ({
  compare,
  updateCompare,
  getCompareQueryMetadata,
  isDisabled = false,
}: TimePeriodSelectorProps) => {
  const { compareDateRange } = usePageConfiguration();
  const hasCompareDateRange = !!compareDateRange;
  const canSelect = !isDisabled && hasCompareDateRange;
  const compareQueryMetadata = getCompareQueryMetadata({
    queryKey: "compareDateRange",
  });

  return (
    <MenuSubmenuItem
      label={compareQueryMetadata.label}
      icon={compareQueryMetadata.icon}
      isDisabled={!canSelect}
      isSelected={compare.queryKey === "compareDateRange"}
      onClick={() =>
        canSelect &&
        updateCompare({
          ...compare,
          queryKey: "compareDateRange",
          queryValue: null,
        })
      }
      hasChevron={false}
    />
  );
};
